import { isObject } from "lodash";
import { CamelCasedPropertiesDeep } from "type-fest";

// Simple camelCase implementation that works in Edge Runtime
function camelCase(str: string): string {
  return str.replace(/[_-]([a-z0-9])/g, (_, letter: string) => letter.toUpperCase());
}

export type Camelized<T> = CamelCasedPropertiesDeep<T>;
export const ignoreKeys = ["upgradePermissions"];

function camelize<T extends object>(obj: T): Camelized<T> {
  if (obj === null || obj === undefined) return obj as Camelized<T>;
  return Object.keys(obj).reduce((acc, key) => {
    let _key = key;
    if (typeof key === "string" && !key.startsWith("__")) {
      _key = camelCase(key);
    }

    const value = obj[key];
    if (Array.isArray(value)) {
      acc[_key] = value.map(item => (isObject(item) ? camelize(item) : item));
    } else if (isObject(value) && !ignoreKeys.includes(_key)) {
      acc[_key] = camelize(value);
    } else {
      acc[_key] = value;
    }
    return acc;
  }, {} as Camelized<T>);
}
export default camelize;
